/**
 * Sentinel for "Locatie naar keuze" (partner comes to the customer). Shared so the
 * cart, wishlist, and location dropdowns don't each hard-code the persisted string.
 */
export const LOCATION_CUSTOM_VALUE = 'custom' as const;

/**
 * Maps the UI's location choice to the persisted `cart_item` columns.
 * `'custom'` = "Locatie naar keuze" (partner comes to the customer), a number is
 * a fixed partner venue, `null` clears the choice.
 */
export function cartItemLocationToColumns(location: typeof LOCATION_CUSTOM_VALUE | number | null): {
    locationType: 'CUSTOM' | 'ADDRESS' | null;
    addressId: number | null;
} {
    if (location === LOCATION_CUSTOM_VALUE) return { locationType: 'CUSTOM', addressId: null };
    if (typeof location === 'number') return { locationType: 'ADDRESS', addressId: location };
    return { locationType: null, addressId: null };
}
